import { AbstractControl, UntypedFormArray, UntypedFormGroup } from '@angular/forms';

type AbstractControlWithMaybeControls = AbstractControl & {
  controls?: { [key: string]: AbstractControl };
};

/**
 * Removes all entries of a FormArray
 * @param formArray
 */
export function clearFormArray(formArray: UntypedFormArray) {
  while (formArray.length !== 0) {
    formArray.removeAt(0);
  }
}

/**
 * Mark form as dirty and validate the form and all descendants
 * @param form
 */
export function dirtyAndValidate(form: UntypedFormGroup = this.form) {
  form.markAsDirty();
  updateValidityState(form);
}

/**
 * Updates validity state for all descendants of the given form group
 * @param form
 * @param options
 */
export function updateValidityState(
  form: AbstractControlWithMaybeControls,
  options?: {
    onlySelf?: boolean;
    emitEvent?: boolean;
  }
) {
  if (form.controls) {
    Object.keys(form.controls).forEach((key) => {
      const control: AbstractControlWithMaybeControls = form.controls[key];

      if (control.controls) {
        updateValidityState(control, options);
      } else {
        control.updateValueAndValidity(options);
      }
    });
  }
}

/**
 * Removes a custom error of the given control and set's the errors to null if no other errors exist
 * @param control Abstract control
 */
export function clearCustomErrors(control: AbstractControl): void {
  if (control.errors !== null) {
    const { custom, ...other } = control.errors;

    if (other == null || Object.keys(other).length === 0) {
      control.setErrors(null);
    } else {
      control.setErrors(other);
    }
  }
}
